const DOMAINS = {
  RUNTIME: 'Runtime',
  MONITORING: 'Monitoring',
  INTEGRATIONS: 'Integrations',
  IAM: 'IAM',
  COLLABORATION: 'Collaboration',
  DOCUMENTATION: 'Documentation',
  API_DEV_PLATFORM: 'API Dev Platform',
  VERSION_CONTROL: 'Version Control',
  API_DESIGN_MOCK: 'API Design and Mock',
  API_NETWORK: 'API Network',
  ONBOARDING: 'Onboarding',
  CLIENT_FOUNDATION: 'Client Foundation',
  API_SECURITY_AUTOMATION: 'API Security Automation',
  BILLING: 'Billing',
  REPORTING_AND_SEARCH: 'Reporting and Search'
};

export default DOMAINS;
